/**
 * Return CSS text containing dimensions for iframe, constrained to given
 * wrapper object dimensions
 *
 * @param {HTMLElement} wrapper Wrapper element for positioning
 * @returns {string} css text
 */
export default function getIframeCSSText(wrapper) {
  const dimensions = wrapper.getBoundingClientRect();
  const scrollOffset = window.scrollY;

  return `
    height: ${dimensions.height}px;
    left: ${dimensions.left}px;
    top: ${dimensions.top + scrollOffset}px;
    width: ${dimensions.width}px;
  `;
}
